import { KeyboardArrowRight } from '@mui/icons-material';
import { IActividad } from '../../../../../interfaces/logic.interface';

export const serviceSelectAdapter = (
	data: IActividad[],
	functionView: (item: IActividad) => void
): IActividad[] => {
	const niveles: IActividad[] = data.map((nivel: IActividad) => {
		return {
			...nivel,
			acciones: (
				<span
					id={`view-${nivel._id}`}
					onClick={() => functionView(nivel)}
					style={{ cursor: 'pointer' }}
				>
					<KeyboardArrowRight />
				</span>
			),
		};
	});
	return niveles;
};
